/**
 * @license
 *-------------------------------------------------------------------------------------------
 * Copyright © 2025 Progress Software Corporation. All rights reserved.
 * Licensed under commercial license. See LICENSE.md in the package root for more information
 *-------------------------------------------------------------------------------------------
 */
const t = ":not(.k-dropdownlist button):not(.k-colorpicker button):not(.k-split-button .k-split-button-arrow)", o = [
  "button" + t,
  ".k-button-group > button" + t,
  ".k-colorpicker",
  ".k-dropdownlist"
];
export {
  o as toolbarButtons
};
